export const WIZARD_STEP_IDS = {
  BASICS: 'basics',
  SCHEDULE: 'schedule',
  RULES: 'rules',
  BLOCKING: 'blocking',
  PAYMENT: 'payment',
  IMAGES: 'images'
};

export const AMENITY_WIZARD_TOTAL_STEPS = 7;

export const AMENITY_WIZARD_STEP_INDICES = {
  BASICS: 0,
  SCHEDULE: 1,
  RULES: 2,
  BLOCKING: 3,
  PAYMENT: 4,
  IMAGES: 5,
  REVIEW: 6
};

export function getAmenityWizardStepCount() {
  return AMENITY_WIZARD_TOTAL_STEPS;
}

export function getAmenityRulesStepIndex() {
  return AMENITY_WIZARD_STEP_INDICES.RULES;
}

export function getAmenityBlockingStepIndex() {
  return AMENITY_WIZARD_STEP_INDICES.BLOCKING;
}

export function getAmenityPaymentStepIndex() {
  return AMENITY_WIZARD_STEP_INDICES.PAYMENT;
}

export function getAmenityImagesStepIndex() {
  return AMENITY_WIZARD_STEP_INDICES.IMAGES;
}

export function getAmenitySubmitStepIndex() {
  return AMENITY_WIZARD_STEP_INDICES.REVIEW;
}

export function shouldShowBlockingStep({ allowBooking } = {}) {
  return !!allowBooking;
}

export function shouldShowPaymentStep({ allowBooking, requiresPayment } = {}) {
  return !!allowBooking && !!requiresPayment;
}

export function getNextStepAfterRules({ allowBooking } = {}) {
  return allowBooking
    ? AMENITY_WIZARD_STEP_INDICES.BLOCKING
    : AMENITY_WIZARD_STEP_INDICES.IMAGES;
}

export function getNextStepAfterBlocking({ requiresPayment } = {}) {
  return requiresPayment
    ? AMENITY_WIZARD_STEP_INDICES.PAYMENT
    : AMENITY_WIZARD_STEP_INDICES.IMAGES;
}

export function getPreviousStepBeforeImages({ allowBooking, requiresPayment } = {}) {
  if (allowBooking && requiresPayment) {
    return AMENITY_WIZARD_STEP_INDICES.PAYMENT;
  }
  if (allowBooking) {
    return AMENITY_WIZARD_STEP_INDICES.BLOCKING;
  }
  return AMENITY_WIZARD_STEP_INDICES.RULES;
}

export function getAmenitySkippedStepsNotice({ allowBooking, requiresPayment } = {}, t) {
  if (!allowBooking) {
    return t('add_amenity_non_bookable_steps_skipped', {
      defaultValue:
        "Steps 4–5 skipped as blocking and payment settings don't apply to non-bookable amenities."
    });
  }
  if (!requiresPayment) {
    return t('add_amenity_payment_step_skipped', {
      defaultValue: "Step 5 skipped as payment settings don't apply to this amenity."
    });
  }
  return null;
}

export function getAddAmenityWizardTitle(t) {
  return t('Add Amenity', { defaultValue: 'Add Amenity' });
}

export function getAddAmenityWizardChromeProps(
  stepIndex,
  t,
  { stepName, stepDescription, displayTotalSteps }
) {
  return {
    stepIndex,
    displayTotalSteps,
    title: getAddAmenityWizardTitle(t),
    stepName,
    stepDescription
  };
}
